import { fsmData } from '../../../../universal';
import { _ } from '../../../lib';
import { Alerts } from '../../component-main';
import { reactForceAllUpdate } from '../../component-react';
import { FormType, openFlyoutForm } from '../form';
export var Action;
(function (Action) {
    Action[Action["UpdateReportJob"] = 0] = "UpdateReportJob";
    Action[Action["UpdateOuterWidths"] = 1] = "UpdateOuterWidths";
    Action[Action["UpdateInnerWidths"] = 2] = "UpdateInnerWidths";
    Action[Action["AddReport"] = 3] = "AddReport";
    Action[Action["DeleteReport"] = 4] = "DeleteReport";
    Action[Action["UpdateReport"] = 5] = "UpdateReport";
})(Action || (Action = {}));
export const getDefaultState = (props) => ({
    selectedReportJob: props.view?.selectedReportJob,
    selectedReport: props.view?.selectedReport,
    searchText: props.view?.searchText ?? '',
    compactView: props.view?.compactView ?? false,
    reportJobs: props.reportJobs,
    widthsOuter: props.view?.widthsOuter ?? null,
    widthsInner: props.view?.widthsInner ?? null,
    isLoading: {},
    errorMessage: {},
    cache: null,
});
export const getPartialStateFromAction = (rs, p) => {
    switch (p[0]) {
        case Action.UpdateReportJob:
            const rj_key = p[1];
            const curr = rs.state.reportJobs[rj_key ?? -1];
            if (!rj_key || !curr) {
                return {};
            }
            return {
                reportJobs: {
                    ...rs.state.reportJobs,
                    [rj_key]: {
                        ...curr,
                        ...p[2](curr),
                    },
                },
            };
        case Action.UpdateOuterWidths:
            return { widthsOuter: p[1] };
        case Action.UpdateInnerWidths:
            return { widthsInner: p[1] };
        case Action.AddReport:
            const rjID = p[1].rj;
            const rj = rs.state.reportJobs[rjID];
            if (!rj) {
                return {};
            }
            const lowestNewID = fsmData(rj.Reports, {
                filter: x => x.ID < 0,
                sort: x => x.ID,
                map: x => x?.ID ?? 0,
                takeFirst: true,
            });
            const newID = lowestNewID - 1;
            return {
                selectedReportJob: rjID,
                selectedReport: newID,
                reportJobs: {
                    ...rs.state.reportJobs,
                    [rjID]: {
                        ...rj,
                        Reports: {
                            ...rj.Reports,
                            [newID]: {
                                ID: newID,
                                ReportJob: rjID,
                                ExportType: 1,
                                Name: '',
                                Type: null,
                                Params: {},
                                OverriddenParams: [],
                            },
                        },
                    },
                },
            };
        case Action.DeleteReport:
            const rj2 = rs.state.reportJobs[p[1].rj];
            if (!rj2) {
                return {};
            }
            return {
                selectedReport: null,
                reportJobs: {
                    ...rs.state.reportJobs,
                    [rj2.ID]: {
                        ...rj2,
                        Reports: _.omit(rj2.Reports, p[1].report),
                    },
                },
            };
        case Action.UpdateReport:
            const rj3 = rs.state.reportJobs[p[1].rj];
            const report = rj3?.Reports[p[1].rpt ?? 0];
            if (!rj3 || !report) {
                return {};
            }
            return {
                reportJobs: {
                    ...rs.state.reportJobs,
                    [rj3.ID]: {
                        ...rj3,
                        Reports: {
                            ...rj3.Reports,
                            [p[1].rpt]: {
                                ...report,
                                ...p[1].update(report),
                            },
                        },
                    },
                },
            };
    }
};
export const sendOnUpdate = (rs, delta) => {
    requestAnimationFrame(() => {
        rs.props.onUpdate({
            selectedReportJob: rs.state.selectedReportJob,
            selectedReport: rs.state.selectedReport,
            searchText: rs.state.searchText,
            compactView: rs.state.compactView,
            widthsOuter: rs.state.widthsOuter ?? null,
            widthsInner: rs.state.widthsInner ?? null,
            ...delta,
        });
    });
};
export const actionAddReportJob = (rs) => {
    openFlyoutForm({
        title: 'Add Report Job',
        size: [320, null],
        fields: {
            name: FormType.Text({
                lbl: 'Name',
                doc: 'The name of the report job',
                autoCapitalize: true,
                minLength: 3,
                maxLength: 40,
            }),
        },
        formPrompt: 'The user is adding a new report job',
        lblWidth: 60,
        onSave: (model, callback) => {
            rs.props.onAdd(model.current.name, IDorError => {
                if (_.isString(IDorError)) {
                    callback(IDorError);
                    return;
                }
                reactForceAllUpdate();
                callback(true);
                updateStateWhenDefined(() => rs.props.reportJobs[IDorError], rj => {
                    rs.updateState(s => ({
                        selectedReportJob: IDorError,
                        selectedReport: null,
                        reportJobs: {
                            ...s.reportJobs,
                            [IDorError]: rj,
                        },
                    }));
                });
            });
        },
    });
};
const updateStateWhenDefined = (getDefinedValue, update, count) => {
    const item = getDefinedValue();
    if (!item) {
        if ((count ?? 0) > 10) {
            console.error('Took more than 10 animation frames to get defined value - aborting.');
            return;
        }
        requestAnimationFrame(() => {
            updateStateWhenDefined(getDefinedValue, update, (count ?? 0) + 1);
        });
        return;
    }
    update(item);
};
export const actionAttemptDelete = (rs, rj) => {
    Alerts.Confirm({
        msg: 'Are you sure you want to delete this report job?',
        yes: () => {
            rs.updateState(() => ({
                isLoading: {
                    ...rs.state.isLoading,
                    [rj]: true,
                },
                errorMessage: {
                    ...rs.state.errorMessage,
                    [rj]: '',
                },
            }));
            rs.props.onDelete(rj, (goodOrError) => {
                rs.updateState(() => ({
                    isLoading: {
                        ...rs.state.isLoading,
                        [rj]: false,
                    },
                }));
                if (goodOrError !== true) {
                    rs.updateState(() => ({
                        errorMessage: {
                            ...rs.state.errorMessage,
                            [rj]: goodOrError,
                        },
                    }));
                    return;
                }
                reactForceAllUpdate();
                rs.updateState(s => ({
                    selectedReportJob: null,
                    selectedReport: null,
                    reportJobs: _.omitBy(s.reportJobs, x => x.ID == rj),
                }));
            });
        },
    });
};
export const actionAttemptSave = (rs, rj) => {
    const rj_original = rs.props.reportJobs[rj ?? -1];
    const rj_internal = rs.state.reportJobs[rj ?? -1];
    if (!rj_internal || !rj_original) {
        return;
    }
    const deletedReports = _.difference(_.map(rj_original.Reports, x => x.ID), _.map(rj_internal.Reports, x => x.ID));
    const duplicate = _.chain(rj_internal.Reports)
        .map(x => getFilename(x))
        .groupBy()
        .map((v, k) => [k, v.length])
        .filter(x => x[1] > 1)
        .map(x => x[0])
        .first()
        .value();
    if (duplicate != null) {
        rs.updateState(s => ({
            errorMessage: {
                ...s.errorMessage,
                [rj ?? -1]: `Duplicate filename "${duplicate}"`,
            },
        }));
        return;
    }
    const reportJob = {
        ...rj_internal,
        Reports: _.mapValues(rj_internal.Reports, rpt => ({
            ...rpt,
            Type: rpt.Type ?? '',
        })),
    };
    rs.updateState(s => ({
        isLoading: {
            ...s.isLoading,
            [rj ?? -1]: true,
        },
        errorMessage: {
            ...s.errorMessage,
            [rj ?? -1]: '',
        },
    }));
    rs.props.onSave(reportJob, deletedReports, goodOrError => {
        rs.updateState(s => ({
            isLoading: {
                ...s.isLoading,
                [rj ?? -1]: false,
            },
        }));
        if (goodOrError !== true) {
            rs.updateState(s => ({
                errorMessage: {
                    ...s.errorMessage,
                    [rj ?? -1]: goodOrError,
                },
            }));
            return;
        }
        reactForceAllUpdate();
        requestAnimationFrame(() => {
            updateStateWhenDefined(() => rs.props.reportJobs[rj ?? -1], rjObj => {
                rs.updateState(s => ({
                    selectedReport: !s.selectedReport || s.selectedReport < 0
                        ? null
                        : s.selectedReport,
                    reportJobs: {
                        ...s.reportJobs,
                        [rj ?? -1]: rjObj,
                    },
                }));
            });
        });
    });
};
const getFilename = (rj) => {
    const name = rj.Name.replace(/[^a-zA-Z0-9-]/g, '-');
    const ext_map = { 1: 'pdf', 2: 'xlsx', 3: 'csv' };
    const ext = ext_map[rj.ExportType];
    return `${name}.${ext}`;
};
//# sourceMappingURL=actions.js.map